<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <div class="header-button">
      <search-form
        ref="searchForm"
        :fields="search"
      />
      <div class="selections">
        <button-link
          type="success"
          to="/coupon/create"
        >
          <slot>添加优惠券</slot>
        </button-link>

        <el-button
          type="info"
          @click="dialogVisibleSongQuan=true"
        >赠送优惠券</el-button>
      </div>
    </div>

    <el-table
      :data="coupon"
      resource="coupon"
    >
      <!--<el-table-column
        prop="id"
        label="ID"
        width="60"
        align="center"
      />-->
      <el-table-column
        prop="title"
        label="名称"
        min-width="150"
        align="center"
      />
      <el-table-column
        prop="type_name"
        label="优惠券类型"
        show-overflow-tooltip
        min-width="100"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag type="success">{{ scope.row.type_name }}</el-tag>

        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="area_name"
        label="区域"
        show-overflow-tooltip
        min-width="7%"
        align="center"
     
      >
       
        <template slot-scope="scope" >
          <el-tag type="success"   v-if="area_name">{{ scope.row.area_name }}</el-tag>
           <el-tag type="success" v-else-if="area_name==''">全部</el-tag>
          
        </template>
      
        
        
      </el-table-column>-->
      <el-table-column
        prop="area_name"
        label="区域"
        show-overflow-tooltip
        min-width="120"
        align="center"
      >

        <template slot-scope="scope">
          <el-tag
            type="success"
            v-show="scope.row.area_name"
          >{{scope.row.area_name }}</el-tag>
          <el-tag
            type="success"
            v-show="!scope.row.area_name"
          >全部</el-tag>

        </template>

      </el-table-column>

      <el-table-column
        prop="with_amount"
        label="满多少金额（折扣）"
        min-width="100"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag
            type="info"
            v-if="scope.row.type==1"
          >{{ scope.row.with_amount }}</el-tag>
          <el-tag
            type="info"
            v-if="scope.row.type==3"
          >{{ scope.row.discount/10 }} 折</el-tag>
          <el-tag
            type="info"
            v-if="scope.row.type==2"
          >无</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="used_amount"
        label="(最多)可减金额"
        min-width="100"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag type="danger">{{ scope.row.used_amount }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="quota_type_name"
        label="是否限制发放数量"
        show-overflow-tooltip
        min-width="120"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag>{{ scope.row.quota_type_name }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="site"
        label="类型"
        show-overflow-tooltip
        min-width="100"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag v-show="scope.row.site==0">订单优惠券类型</el-tag>
          <el-tag v-show="scope.row.site==1">新用户注册类型</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="is_discount"
        label="是否折扣"
        width="80"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_discount" type="success">有折扣</el-tag>
          <el-tag v-else type="danger">无折扣</el-tag>
        </template>
      </el-table-column> -->
      <!-- <el-table-column
        prop="discount"
        label="折扣"
        width="80"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag>{{ scope.row.discount * 10 }} 折</el-tag>
        </template>
      </el-table-column> -->

      <!-- <el-table-column prop="area" label="区域">
        <template #default="{ row }">
          <el-tag
            v-for="i of row.areas"
            :key="i.id"
            class="mr-1"
          >
            {{ i.name }}
          </el-tag>
        </template>
      </el-table-column> -->

      <el-table-column
        label="状态"
        min-width="100"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.status == 1"
            type="success"
          >启用</el-tag>
          <el-tag
            v-else-if="scope.row.status == 0"
            type="danger"
          >失效</el-tag>
          <el-tag
            v-else-if="scope.row.status == 2"
            type="danger"
          >已使用</el-tag>
        </template>
      </el-table-column>

      <el-table-column
        prop="created_at"
        label="添加时间"
        min-width="160"
        align="center"
      />
      <el-table-column
        label="操作"
        width="250"
        align="center"
      >
        <template #default="{ row, $index }">
          <el-button-group>
            <row-to-edit />
            <row-destroy />

            <el-button
              type="success"
              @click="dialogVisibleClick(row)"
              size="small"
            >详情</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="详情"
      :visible.sync="dialogVisible"
      width="20%"
    >
      <div class="info-wrp">
        <div class="title">优惠券详情</div>
        <div class="info-item">
          <span>优惠券名称:</span>
          <span>{{ rows.title }}</span>
        </div>
        <div class="info-item">
          <span>优惠券类型:</span>
          <span>{{ rows.type_name }}</span>
        </div>
        <div
          class="info-item"
          v-show="rows.type==1"
        >
          <span>满多少金额:</span>
          <span>{{ rows.with_amount }}</span>
        </div>
        <div class="info-item">
          <span>可减少金额:</span>
          <span>{{ rows.used_amount }}</span>
        </div>
        <div class="info-item">
          <span>是否限制发券量:</span>
          <span>{{ rows.quota_type_name }}</span>
        </div>
        <div
          class="info-item"
          v-show="rows.is_quota==1"
        >
          <span>总可发券数量:</span>
          <span style="width:60%;">{{ rows.quota }}</span>
        </div>
        <div class="info-item">
          <span>已发券数量:</span>
          <span style="width:60%;">{{ rows.take_count }}</span>
        </div>
        <div class="info-item">
          <span>券已使用数量:</span>
          <span style="width:60%;">{{ rows.used_count }}</span>
        </div>
        <div class="info-item">
          <span>发放开始时间:</span>
          <span style="width:60%;">{{ rows.grant_start_at }}</span>
        </div>
        <div class="info-item">
          <span>发放结束时间:</span>
          <span style="width:60%;">{{ rows.grant_end_at }}</span>
        </div>
        <div class="info-item">
          <span>时效类型:</span>
          <span style="width:60%;">{{ rows.valid_type_name }}</span>
        </div>
        <div
          class="info-item"
          v-show="rows.valid_type==2"
        >
          <span>自领取起有效天数:</span>
          <span style="width:60%;">{{ rows.valid_days }}</span>
        </div>
        <div
          class="info-item"
          v-show="rows.valid_type==1"
        >
          <span>生效日期:</span>
          <span style="width:60%;">{{ rows.valid_start_time }}</span>
        </div>
        <div
          class="info-item"
          v-show="rows.valid_type==1"
        >
          <span>失效日期:</span>
          <span style="width:60%;">{{ rows.valid_end_time }}</span>
        </div>
        <div class="info-item">
          <span>状态:</span>
          <span style="width:60%;">{{ rows.status_name }}</span>
        </div>
      </div>
    </el-dialog>
    <!-- 弹框详情信息end -->

    <el-dialog
      title="赠送用户优惠券"
      :visible.sync="dialogVisibleSongQuan"
      width="30%"
    >
      <!-- <span>这是一段信息</span>
      -->

      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="150px"
      >
        <el-form-item
          prop="coupon_id"
          required
          label="优惠券"
        >
          <el-select
            class="limit-width"
            v-model="form.coupon_id"
            placeholder="请选择"
          >
            <el-option
              v-for="item in coupons"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="用户手机号"
          required
          prop="mobile"
        >
          <el-input
            @keyup.enter.native="searchUser"
            v-model="form.mobile"
          />
        </el-form-item>
        <el-form-item
          label="用户名（真名）"
          v-show="is_show_user"
        >
          <span>{{ nickname }}({{ truename }})</span>
        </el-form-item>
        <el-form-item
          label="头像"
          v-show="is_show_user"
        >
          <img
            :src="avatar"
            min-width="30"
            height="30"
          >
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVisibleSongQuan = false">取 消</el-button>
        <el-button
          type="primary"
          @click="songquan"
        >确 定</el-button>
      </span>
    </el-dialog>
    <div class="card-footer">
      <pagination :page="page" />
    </div>
  </el-card>
</template>

<script>
import SearchForm from "@c/SearchForm";
import Pagination from "@c/Pagination";
import { getCoupon, giveCouponToUser } from "@/api/coupon";
import RowDestroy from "@c/LzTable/RowDestroy";
import RowToEdit from "@c/LzTable/RowToEdit";
import ButtonLink from "@c/ButtonLink";
import { getAreas } from "@/api/area";
import { mixinsAutoPageSize } from "@/libs/utils";
import { getUserByMobile } from "@/api/users";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import env from "../../../env";
export default {
  name: "Index",
  components: {
    RowToEdit,
    RowDestroy,
    SearchForm,
    Pagination,
    ButtonLink
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      dialogVisible: false,
      search: [
        {
          type: "el-select",
          field: "area_id",
          label: "骑行区域",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        },
        {
          field: "title",
          label: "名称"
        },
        {
          type: "el-select",
          field: "valid_type",
          label: "选择时效",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              id: 1,
              name: "绝对时效"
            },
            {
              id: 2,
              name: "相对时效"
            }
          ]
        },
        {
          type: "el-select",
          field: "status",
          label: "是否禁用",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              id: 1,
              name: "启用"
            },
            {
              id: 0,
              name: "禁用"
            }
          ]
        },
        {
          type: "el-select",
          field: "is_quota",
          label: "是否限制发券数量",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              id: 1,
              name: "限制"
            },
            {
              id: 0,
              name: "不限制"
            }
          ]
        }
      ],
      coupon: [],
      page: null,
      first_blood: true,
      card_name: "",
      area_id: 3,
      areas: [
        {
          area_id: 0,
          area_name: "全部"
        }
      ],
      rows: {},
      dialogVisibleSongQuan: false,
      is_show_user: false,
      coupons: [],
      form: {
        mobile: "",
        coupon_id: ""
      },
      truename: "",
      nickname: "",
      avatar: "",
      rules: {
        coupon_id: [
          { required: true, message: "请选择赠送得优惠券", trigger: "change" }
        ],
        mobile: [{ validator: checkPhone, trigger: "blur" }]
      }
    };
  },
  async created() {
    const [{ data: areas }] = await Promise.all([getAreas({ all: 1 })]);

    this.areas = this.areas.concat(areas);
    // this.areas=areas
    console.log(areas[1].area_name, "区域");
    this.search[0].options.push.apply(this.search[0].options, this.areas);

    const { data: coupons } = await getCoupon({ all: 1 });
    this.coupons = coupons;
    if (this.$store.state.users.user.roles[0] === "administrator") {
      const [{ data: merchant }] = await Promise.all([
        getAdminUsersMerchant({ all: 1 })
      ]);
      if (env.isPosSwitch == true) {
        this.search.push({
          type: "el-select",
          field: "merchant_id",
          label: "商户",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        });
        this.search[5].options.push.apply(
          this.search[5].options,
          merchant.data
        );
      }
    }
  },
  mixins: [mixinsAutoPageSize],
  watch: {
    $route: {
      async handler(newVal) {
        await this.autoPageSize(53, newVal);
        const {
          data: { data, meta }
        } = await getCoupon(newVal.query);
        this.coupon = data;
        this.page = meta;
      },
      immediate: true
    }
  },
  methods: {
    dialogVisibleClick(row) {
      this.rows = row;
      this.dialogVisible = true;
    },
    songquan() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          giveCouponToUser(this.form).then(res => {
            res.then(data => {
              if (data) {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.dialogVisibleSongQuan = false;
                this.form.coupon_id = "";
                this.form.mobile = "";
                this.is_show_user = false;
              }
            });
          });
        } else {
          alert("请检查输入内容");
          return false;
        }
      });
    },
    async searchUser() {
      // console.log(this.form.mobile)
      const [{ data: user }] = await Promise.all([
        getUserByMobile({ mobile: this.form.mobile })
      ]);
      this.truename = user.truename;
      this.nickname = user.nickname;
      this.avatar = user.avatar;
      this.is_show_user = true;
      // console.log(user)
    }
  }
};
</script>
<style lang="scss" scoped>
.header-button {
  display: flex;
  justify-content: space-between;
  .selections {
    display: inline-block;
    margin-right: 10px;
  }
}
.info-wrp .title {
  font-size: 16px;
  // margin: 20px 0 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-top: 1px solid #ccc;
}
.info-wrp .info-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 10px;
}
.info-wrp .info-item > span:first-child {
  display: inline-block;
  margin-right: 8px;
  width: 120px;
  text-align: right;
}
.info-wrp .pic-wrp > div:first-child {
  width: 120px;
  text-align: right;
}
.infodiv {
  line-height: 1.15;
  // border-top: 1px solid #ccc;
  padding-bottom: 10px;
  .title {
    border-top: 1px solid #ccc;
    font-size: 16px;
    margin: 10px;
    padding-top: 10px;
  }
  .info-item {
    margin-left: 30px;
    margin-bottom: 10px;
    :first-child {
      display: inline-block;
      width: 85px;
      text-align: right;
      font-size: 14px;
      margin-right: 8px;
    }
  }
}
</style>
